import React, { type Dispatch, type SetStateAction } from "react";
import cx from "classnames";
import type { SORTING_CRITERIA } from "variables";
import { Icon } from "../Icon/Icon";
import s from "./SortButton.module.scss";

type SortButtonProps = {
  disabled?: boolean;
  sortCriteria: (typeof SORTING_CRITERIA)[keyof typeof SORTING_CRITERIA];
  setSortCriteria: Dispatch<SetStateAction<string>>;
  currentSort: string;
  isOrderDescending: boolean;
  setIsOrderDescending: Dispatch<SetStateAction<boolean>>;
  setCurrentPageNo: Dispatch<SetStateAction<number>>;
  setIsSelectAll?: Dispatch<SetStateAction<boolean>>;
  setProjectsToDelete?: Dispatch<SetStateAction<string[]>>;
};

export const SortButton = React.memo(
  ({
    disabled = false,
    sortCriteria,
    setSortCriteria = () => {},
    currentSort,
    isOrderDescending,
    setIsOrderDescending,
    setCurrentPageNo,
    setIsSelectAll = () => {},
    setProjectsToDelete = () => {},
  }: SortButtonProps) => {
    const isActive = sortCriteria === currentSort;

    const handleClick = () => {
      if (disabled) {
        return;
      }
      setSortCriteria(sortCriteria);
      if (!isActive) {
        setIsOrderDescending(false);
      } else {
        setIsOrderDescending((prev) => !prev);
      }
      setCurrentPageNo(1);
      setIsSelectAll(false);
      setProjectsToDelete([]);
    };

    return (
      <button
        onClick={handleClick}
        className={cx(
          "mx-1 p-0 border-0 bg-transparent text-gray-700 d-flex align-items-center",
          {
            "text-gray-400": disabled,
          },
        )}
        disabled={disabled}
      >
        <Icon
          iconName="arrow-up-regular"
          className={cx(s.arrowRight, {
            "text-blue-300": !isOrderDescending && !disabled && isActive,
          })}
        />
        <Icon
          iconName="arrow-up-regular"
          className={cx(s.arrowDown, "rotate-180", {
            "text-blue-300": isOrderDescending && isActive,
          })}
        />
      </button>
    );
  },
);
